// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._v56416r9{transition:opacity .3s ease-in-out,r .3s ease-in-out}", ""]);
// Exports
module.exports = exports;
